import React, {
    useEffect,
    useState
} from "react";

const ReplaceEmployeeModal = ({

    show,
    onClose,
    onSubmit,
    replaceEmployee

}) => {

    const [
        selectedBranch,
        setSelectedBranch
    ] = useState("");

    const [
        trainers,
        setTrainers
    ] = useState([]);

    const [
        selectedStaff,
        setSelectedStaff
    ] = useState(null);

    const [
        selectedMentor,
        setSelectedMentor
    ] = useState(null);

    // =====================================
    // FETCH TRAINERS
    // =====================================

    const fetchTrainers =
        async (branch) => {

            try {

                const response =
                    await fetch(

                        `${process.env.REACT_APP_API_URL}/trainers?branch=${branch}`

                    );

                const data =
                    await response.json();

                setTrainers(data);

            }

            catch (error) {

                console.error(error);

            }

        };

    // =====================================
    // BRANCH CHANGE
    // =====================================

    const handleBranchChange =
        (e) => {

            const branch =
                e.target.value;

            setSelectedBranch(branch);

            fetchTrainers(branch);

        };

    // =====================================
    // STAFF CHANGE
    // =====================================

    const handleStaffChange =
        (e) => {

            const emp =
                trainers.find(

                    t =>
                        String(t.emp_id) ===
                        e.target.value

                );

            setSelectedStaff(emp);

        };

    // =====================================
    // MENTOR CHANGE
    // =====================================

    const handleMentorChange =
        (e) => {

            const emp =
                trainers.find(

                    t =>
                        String(t.emp_id) ===
                        e.target.value

                );

            setSelectedMentor(emp);

        };

    // =====================================
    // RESET
    // =====================================

    useEffect(() => {

        if (!show) {

            setSelectedBranch("");

            setTrainers([]);

            setSelectedStaff(null);

            setSelectedMentor(null);

        }

    }, [show]);

    if (!show) return null;

    return (

        <div className="modal-overlay">

            <div className="employee-details-modal replace-modal">

                <div className="modal-header">

                    <h2>
                        Replace Employee Mapping
                    </h2>

                    <button
                        className="close-btn"
                        onClick={onClose}
                    >
                        ×
                    </button>

                </div>

                <div className="modals-content">

                    {/* OLD EMPLOYEE */}

                    <div className="replace-section">

                        <h3>
                            Old Employee
                        </h3>

                        <div className="replace-grid">

                            <div className="form-group">

                                <label>
                                    Employee ID
                                </label>

                                <input
                                    type="text"
                                    value={
                                        replaceEmployee?.emp_id || ""
                                    }
                                    readOnly
                                />

                            </div>

                            <div className="form-group">

                                <label>
                                    Employee Name
                                </label>

                                <input
                                    type="text"
                                    value={
                                        replaceEmployee?.emp_name || ""
                                    }
                                    readOnly
                                />

                            </div>

                            <div className="form-group">

                                <label>
                                    Contact Number
                                </label>

                                <input
                                    type="text"
                                    value={
                                        replaceEmployee?.contact_num || ""
                                    }
                                    readOnly
                                />

                            </div>

                        </div>

                    </div>

                    {/* BRANCH */}

                    <div className="form-group">

                        <label>
                            Select Branch
                        </label>

                        <select
                            value={selectedBranch}
                            onChange={handleBranchChange}
                        >

                            <option value="">
                                Select Branch
                            </option>

                            {Array.isArray(
                                replaceEmployee?.branch
                            ) ? (

                                replaceEmployee.branch.map(
                                    (branch, index) => (

                                        <option
                                            key={index}
                                            value={branch}
                                        >
                                            {branch}
                                        </option>

                                    )
                                )

                            ) : (

                                <option
                                    value={
                                        replaceEmployee?.branch
                                    }
                                >
                                    {
                                        replaceEmployee?.branch
                                    }
                                </option>

                            )}

                        </select>

                    </div>

                    {/* STAFF */}

                    <div className="replace-section">

                        <h3>
                            Replace Staff
                        </h3>

                        <div className="replace-grid">

                            <div className="form-group">

                                <label>
                                    Staff Name
                                </label>

                                <select
                                    onChange={
                                        handleStaffChange
                                    }
                                >

                                    <option value="">
                                        Select Staff
                                    </option>

                                    {trainers.map(
                                        trainer => (

                                            <option
                                                key={
                                                    trainer.emp_id
                                                }
                                                value={
                                                    trainer.emp_id
                                                }
                                            >
                                                {
                                                    trainer.emp_name
                                                }
                                            </option>

                                        )
                                    )}

                                </select>

                            </div>

                            <div className="form-group">

                                <label>
                                    Staff ID
                                </label>

                                <input
                                    type="text"
                                    value={
                                        selectedStaff?.emp_id || ""
                                    }
                                    readOnly
                                />

                            </div>

                          

                        </div>

                    </div>

                    {/* MENTOR */}

                    <div className="replace-section">

                        <h3>
                            Replace Mentor
                        </h3>

                        <div className="replace-grid">

                            <div className="form-group">

                                <label>
                                    Mentor Name
                                </label>

                                <select
                                    onChange={
                                        handleMentorChange
                                    }
                                >

                                    <option value="">
                                        Select Mentor
                                    </option>

                                    {trainers.map(
                                        trainer => (

                                            <option
                                                key={
                                                    trainer.emp_id
                                                }
                                                value={
                                                    trainer.emp_id
                                                }
                                            >
                                                {
                                                    trainer.emp_name
                                                }
                                            </option>

                                        )
                                    )}

                                </select>

                            </div>

                            <div className="form-group">

                                <label>
                                    Mentor ID
                                </label>

                                <input
                                    type="text"
                                    value={
                                        selectedMentor?.emp_id || ""
                                    }
                                    readOnly
                                />

                            </div>

                            <div className="form-group">

                                <label>
                                    Contact Number
                                </label>

                                <input
                                    type="text"
                                    value={
                                        selectedMentor?.contact_num || ""
                                    }
                                    readOnly
                                />

                            </div>

                        </div>

                    </div>

                    <button
                        className="replaces-btn"
                        onClick={() =>
                            onSubmit({

                                newStaffEmpId:
                                    selectedStaff?.emp_id,

                                newMentorEmpId:
                                    selectedMentor?.emp_id

                            })
                        }
                    >
                        Replace Mapping
                    </button>

                </div>

            </div>

        </div>

    );

};

export default ReplaceEmployeeModal;